<template lang="pug">
    div.like
        div
            button-icon(:action="toggleLike" :color="isLikedPost ? '#F73D3E' : 'white'" icon="favorite" size="large")
            div.likeCounter {{likesCounter}}
</template>

<script>
    import VueTypes from 'vue-types';
    import ButtonIcon from '../ButtonIcon';
    import { likes } from '~api';

    export default {
        components: {
            ButtonIcon
        },
        props: {
            session: VueTypes.object.def({})
        },
        data() {
            return {
                likesCounter: 0,
                isLikedPost: false
            };
        },
        watch: {
            session(val) {
                this.isLikedPost = val.isLiked;
                this.likesCounter = val.likeCount;
            }
        },
        created() {
            this.isLikedPost = this.session.isLiked;
            this.likesCounter = this.session.likeCount;
        },
        methods: {
            toggleLike() {
                this.isLikedPost
                    ? likes.removeLike(this.session.id)
                    : likes.addLike(this.session.id);

                this.likesCounter = this.isLikedPost
                    ? --this.likesCounter
                    : ++this.likesCounter;
                this.isLikedPost = !this.isLikedPost;
            }
        }
    };
</script>

<style lang="stylus" scoped>
    @import "../../assets/style/_variables.styl"

    .like
        position: absolute
        bottom: 0
        left: 50%
        transform: translate(-50%, 0)
        color: $theme.white

        >>> i.icon
            font-size: 24px

        > div
            padding: 12px
            display: flex
            align-items: center
            justify-content: center
            font-size: 16px

        .likeCounter
            padding-left: 7px
</style>
